module.exports = __webpack_public_path__ + "img/frontendmentor.beba6679.png";